var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    fill: "none",
    viewBox: "0 0 20 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0q.564 0 1.027.451l8.59 8.793q.19.18.293.406.09.237.09.508 0 .372-.17.677-.18.304-.473.474-.294.18-.666.18a1.3 1.3 0 0 1-.948-.405l-8.296-8.5h1.095l-8.285 8.5a1.3 1.3 0 0 1-.948.406q-.372 0-.666-.18a1.2 1.2 0 0 1-.462-.475A1.3 1.3 0 0 1 0 10.158q0-.53.384-.914L8.973.45A1.372 1.372 0 0 1 10 0"
  })));
};
export default SvgArrowUp;